import React from 'react';

export const ConfigContext = React.createContext({
  showMaquetteMessage: true,
});

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = React.useState({ showMaquetteMessage: true });

  return (
    <ConfigContext.Provider value={{ config, setConfig }}>
      {children}
    </ConfigContext.Provider>
  );
};
